/* Noctimoth cinematic motion v2 — theme-specific, safe, no dependencies */
(function(){
 'use strict';
 var main=document.getElementById('MainContent');
 if(!main || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 var selector=[
 '.hero__content > *','.hero__text > *','.hero__ctas','.hero__proof',
 '.section-head > *','.section > .container > .eyebrow',
 '.story__media','.story__chapters > *','.story__grid > *',
 '.split > *','.split__media','.split__content > *',
 '.tiles > *','.tile','.grid > .card','.card',
 '.trust > *','.quote','.banner__tiers > *','.banner > .container > *',
 '.collection-hero > *','.page-head > *','.blog-card',
 '.product__info > *','.product__title','.product__meta',
 '.product__gallery','.gallery','.product__description',
 '.nm-rating','.nm-badge','.nm-benefits','.nm-stock','.nm-buy','.nm-tier',
 '.nm-reviews','.nm-review','.nm-faq','.nm-once','.nm-perks',
 '.accordion','.accordion > *','.newsletter > *',
 '.rte > p','.rte > h2','.rte > h3'
 ].join(',');
 var o=new IntersectionObserver(function(entries){
  entries.forEach(function(e){
   if(e.isIntersecting){
    e.target.classList.add('nm-flow-visible');
    o.unobserve(e.target);
   }
  });
 },{threshold:0.08,rootMargin:'0px 0px -24px 0px'});
 function scan(root){
  var list=(root||main).querySelectorAll(selector),count=0;
  list.forEach(function(el){
   if(el.dataset.nmAnimated)return;
   if(el.closest('[hidden],[aria-hidden="true"],.drawer,.slider__track,.nm-reviews__track,.gallery__thumbs,.sticky-atc'))return;
   var rect=el.getBoundingClientRect();
   if(rect.width<5 || rect.height<5)return;
   // Never hide content permanently if scripting fails. Reveal immediately if already passed.
   el.dataset.nmAnimated='1';
   el.style.setProperty('--nm-flow-delay',Math.min(count%4*105,315)+'ms');
   if(el.matches('.tile,.card,.story__media,.gallery,.product__gallery'))el.classList.add('nm-flow-image');
   el.classList.add('nm-flow-reveal');
   if(rect.bottom<0)el.classList.add('nm-flow-visible');
   else o.observe(el);
   count++;
  });
 }
 function init(){
  scan(main);
  // Reveal the first-screen hero with a cinematic stagger after paint.
  requestAnimationFrame(function(){requestAnimationFrame(function(){
   main.querySelectorAll('.hero__content .nm-flow-reveal').forEach(function(el){
    el.classList.add('nm-flow-visible');
   });
  });});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',function(e){scan(e.target)});
 var queued=false;
 new MutationObserver(function(m){
  if(queued||!m.some(function(x){return x.addedNodes.length>0}))return;
  queued=true;
  requestAnimationFrame(function(){queued=false;scan(main)});
 }).observe(main,{subtree:true,childList:true});
})();